export default __webpack_public_path__ + "static/media/logo-dark.4498bfcd.svg";